import { render, staticRenderFns } from "./Denounce-link.vue?vue&type=template&id=7b534cbc"
import script from "./Denounce-link.vue?vue&type=script&lang=js"
export * from "./Denounce-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports